module.exports = __webpack_public_path__ + "img/slider2.bc6b955a.jpg";